<template>
  <Container class="flex-col align-start">
    <h2 style="margin:10px 20px">合同借阅管理
      <div style="font-size:12px;color:var(--subtext3);font-weight:bold;">
          涵盖借阅、发放（复印件至项目部查阅）、遗损、销毁等状态；档案类字段待接口对接后可由后台返回
      </div>
    </h2>
    <div class="flex-wrap" style="margin:10px 20px">
      <Input v-model="searchText" search placeholder="输入合同名称搜索" clearable />
      <Button icon="md-refresh" style="margin-left:10px" @click="getData()"></Button>
    </div>
    <div style="padding:0 20px;height:calc(100% - 40px);width:100%;">
      <BaseTable ref="table" :columns="cols" :data="filteredItems" :loading="loading" :count="filteredItems.length" />

    </div>

  </Container>
</template>
<script>
import Container from '@/components/app/container';
import moment from 'moment';

/** 后台未就绪时的默认档案状态（接口返回对应字段后将覆盖） */
const LEDGER_DEFAULTS = {
/** 是否存档 */
is_archived: true,
/** 项目部查阅用印件：issued=已发放 not_issued=未发放 */
project_copy_status: 'issued',
/** 是否遗损 */
is_lost_or_damaged: false,
/** 是否销毁 */
is_destroyed: false,
};

function normalizeLedgerRow(row) {
const projectCopy = row.project_copy_status;
const project_copy_status =
  projectCopy === 'issued' || projectCopy === 'not_issued'
    ? projectCopy
    : LEDGER_DEFAULTS.project_copy_status;

return {
  ...row,
  is_archived: typeof row.is_archived === 'boolean' ? row.is_archived : LEDGER_DEFAULTS.is_archived,
  project_copy_status,
  is_lost_or_damaged:
    typeof row.is_lost_or_damaged === 'boolean' ? row.is_lost_or_damaged : LEDGER_DEFAULTS.is_lost_or_damaged,
  is_destroyed: typeof row.is_destroyed === 'boolean' ? row.is_destroyed : LEDGER_DEFAULTS.is_destroyed,
};
}

export default {
routerOption: {
  as_default: true,
},
components: {Container},
data() {
  return {
    searchText: '',
    page: 1,
    pagesize: 20,
    loading: false,
    items: [],
  };
},
mounted() {
  this.getData();
},
computed: {
  filteredItems() {
    const q = (this.searchText || '').trim().toLowerCase();
    if (!q) {
      return this.items;
    }
    return this.items.filter((row) => {
      const name = (row.name || '').toLowerCase();
      return name.includes(q);
    });
  },
  cols() {
    return [{
      title: '序号',
      width: 60,
      type: 'index',
    }, {
      title: '用印日期',
      width: 120,
      render: (h, {row})=>{
        return h('div', {style: 'color:var(--success)'}, row.signed_at?moment(row.signed_at).format('L'):'-');
      },
    }, {
      title: '合同名称',
      minWidth: 160,
      key: 'name',
      render: (h, {row})=>{
        const icon = h('BaseIcon', {props: {icon: 'contract'}, style: 'margin-right:3px;color:var(--primary)'});
        const name = h('a', row.name);
        return h('div', {class: 'flex-wrap'}, [icon, name]);
      },
    }, {
      title: '是否存档',
      width: 96,
      align: 'center',
      render: (h, {row})=>{
        const yes = row.is_archived;
        return h('span', {style: {color: yes ? 'var(--success)' : 'var(--error)'}}, yes ? '是' : '否');
      },
    }, {
      title: '项目部查阅状态',
      width: 130,
      align: 'center',
      render: (h, {row})=>{
        const issued = row.project_copy_status === 'issued';
        const text = issued ? '已发放' : '未发放';
        const color = issued ? 'var(--success)' : 'var(--warning)';
        return h('span', {style: {color}}, text);
      },
    }, {
      title: '是否遗损',
      width: 96,
      align: 'center',
      render: (h, {row})=>{
        const yes = row.is_lost_or_damaged;
        return h('span', {style: {color: yes ? 'var(--error)' : 'var(--success)'}}, yes ? '是' : '否');
      },
    }, {
      title: '是否销毁',
      width: 96,
      align: 'center',
      render: (h, {row})=>{
        const yes = row.is_destroyed;
        return h('span', {style: {color: yes ? 'var(--error)' : 'var(--success)'}}, yes ? '是' : '否');
      },
    }, {
      title: '使用内容',
      width: 110,
      render: (h) => h('div', {style: 'color:var(--subtext3)'}, '合同借阅'),
    }, {
      title: '借阅原因',
      width: 200,
      render: (h) => h('div', {style: 'color:var(--subtext3)'}, '—'),
    }, {
      title: '申请人',
      width: 120,
      type: 'user',
      key: 'created_by',
    }, {
      title: '审批人',
      width: 120,
      type: 'user',
      key: 'checked_by',
    }, {
      title: '流程',
      width: 120,
      render: (h) => {
        const icon = h('BaseIcon', {props: {icon: 'lianjieliu'}, style: 'margin-right:3px'});
        const buttons = [h('Button', {props: {size: 'small'}}, [icon, '审批记录'])];
        return h('div', {class: 'flex-wrap flex-center'}, buttons);
      },
    }];
  },

},
methods: {
  getData() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.loading = true;
    }
    this.timer = setTimeout(()=>{
      const base_url = `contracts-m/seal_records`;
      const url = base_url;

      this.$api.get(url).then((res)=>{
        const list = res.data.data || [];
        this.items = list.map(normalizeLedgerRow);
      }).catch((e)=>{
        this.Error(e);
      }).finally(()=>{
        setTimeout(()=>{
          this.loading= false;
        }, 300);
      });
    }, 100);
  },
},
};
</script>

<style lang="less">
  .tab-card{
    padding:5px 10px;
    height:100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background:var(--bg3);
    border-right:none;
    cursor: pointer;
    border-radius: 5px;
    .count{
      font-size:30px;
      font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
    }

  }


  .tab-card:hover{
    background:var(--primary);
    color:var(--hover-text);
    .count,.name{
      color:var(--hover-text) !important;
    }
  }

  .tab-card-active{
    background:var(--primary);
    color:var(--hover-text);
    .count,.name{
      color:var(--hover-text) !important;
    }
  }
</style>
